export default "__VITE_ASSET__M4GQ3Sat__"